import { useState, useEffect } from 'react';
import apiService from '../services/api';

export const useWallet = () => {
  const [wallet, setWallet] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const getStoredWalletId = () => {
    return localStorage.getItem('walletId');
  };

  const storeWalletId = (walletId) => {
    localStorage.setItem('walletId', walletId);
  };

  const setupWallet = async (walletData) => {
    setLoading(true);
    setError(null);

    try {
      const newWallet = await apiService.setupWallet(walletData);
      storeWalletId(newWallet.id);
      setWallet(newWallet);
      return newWallet;
    } catch (err) {
      setError(err.message);
      throw err;
    } finally {
      setLoading(false);
    }
  };

  const loadWallet = async (walletId) => {
    if (!walletId) return;

    setLoading(true);
    setError(null);

    try {
      const walletData = await apiService.getWallet(walletId);
      setWallet(walletData);
      return walletData;
    } catch (err) {
      setError(err.message);
      localStorage.removeItem('walletId');
      throw err;
    } finally {
      setLoading(false);
    }
  };

  const createTransaction = async (transactionData) => {
    if (!wallet) throw new Error('No wallet loaded');

    setLoading(true);
    setError(null);

    try {
      const result = await apiService.createTransaction(
        wallet.id,
        transactionData
      );
      setWallet((prev) => ({ ...prev, balance: result.balance }));
      return result;
    } catch (err) {
      setError(err.message);
      throw err;
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const storedWalletId = getStoredWalletId();
    if (storedWalletId) {
      loadWallet(storedWalletId).catch(() => {
        // Wallet not found, clear storage
        localStorage.removeItem('walletId');
      });
    }
  }, []);

  return {
    wallet,
    loading,
    error,
    setupWallet,
    loadWallet,
    createTransaction,
    getStoredWalletId,
  };
};
